require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-como-puede-el-banco-interamericano-de-desarrollo-priorizar.json") })
        }
      }, "path---es-mx-update-como-puede-el-banco-interamericano-de-desarrollo-priorizar");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-como-puede-el-banco-interamericano-de-desarrollo-priorizar!./.cache/json/es-mx-update-como-puede-el-banco-interamericano-de-desarrollo-priorizar.json
// module id = 922
// module chunks = 231608221292675